import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import styles from './Spinner.module.scss';
/** Used to signify a loading state. */ export function Spinner(props) {
    const { className, style, intent = 'default', size = 80, centerBoxHeight, centerBoxWidth, centeredInBox, testId } = props, rest = _object_without_properties(props, [
        "className",
        "style",
        "intent",
        "size",
        "centerBoxHeight",
        "centerBoxWidth",
        "centeredInBox",
        "testId"
    ]);
    const innerStyle = useMemo(()=>({
            borderWidth: size / 20
        }), [
        size
    ]);
    const outerStyle = useMemo(()=>_object_spread({
            width: size,
            height: size
        }, style || {}), [
        size,
        style
    ]);
    const spinner = /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, rest, testId != null ? {
        'data-testid': testId
    } : {}), {
        className: cn(styles.spinner, styles[intent], className),
        style: outerStyle,
        children: [
            /*#__PURE__*/ _jsx("div", {
                style: innerStyle
            }),
            /*#__PURE__*/ _jsx("div", {
                style: innerStyle
            })
        ]
    }));
    return centeredInBox ? /*#__PURE__*/ _jsx("div", {
        className: styles.box,
        style: {
            height: centerBoxHeight,
            width: centerBoxWidth
        },
        children: spinner
    }) : spinner;
}
